<p class="text-center">
  Contacts {{date}}
</p>
